import { render } from "./AccountsTab.vue?vue&type=template&id=50c84a88&scoped=true"
import script from "./AccountsTab.vue?vue&type=script&lang=js"
export * from "./AccountsTab.vue?vue&type=script&lang=js"

import "./AccountsTab.vue?vue&type=style&index=0&id=50c84a88&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c84a88"]])

export default __exports__